import clickpathGetViewType from './clickpathGetViewType';

export default () => {
	const timestamp = Date.now();
	const clickPath = JSON.parse(
		sessionStorage.getItem('ws-tracking-clickpath') || '{}'
	);
	clickPath[timestamp] = {
		path: window.location.href,
		viewType: clickpathGetViewType(),
		timestamp
	};
	sessionStorage.setItem('ws-tracking-clickpath', JSON.stringify(clickPath));
	return timestamp;
};
